import getResponseInput from '@/components/mapper/responseMapper/lib/getResponseInput';
import normalizeToArray from '@/lib/normalizeToArray';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { query } from '@/redux/selectors/querySelectors.js';
import memoizeSelector from '@/redux/lib/memoizeSelector.js';

const useAppScreenResponseInput = ({ settings }) => {
  const activeActionId = settings?.activeActionId;
  const activeStatusId = useSelector((state) => state?.workflow?.activeStatusId);
  const actionOutputs = useSelector(memoizeSelector(`actionOutputs-${activeActionId}`, (state) => state?.workflow?.appActionOutputs?.filter((n) => n?.actionId === activeActionId)));
  const responseMapperId = useArgSelector(query, 'responseMapperId');
  const mapperTab = useArgSelector(query, 'mapperTab');

  const action200Response = useMemo(() => actionOutputs?.find((n) => !n.statusId || (parseFloat(n.statusId) >= 200 && parseFloat(n.statusId) <= 299))?.response, [actionOutputs, activeActionId]);
  const action400Response = useMemo(() => actionOutputs?.find((n) => parseFloat(n.statusId) >= 400 && parseFloat(n.statusId) <= 499)?.response, [actionOutputs, activeActionId]);
  const action500Response = useMemo(() => actionOutputs?.find((n) => parseFloat(n.statusId) >= 500 && parseFloat(n.statusId) <= 599)?.response, [actionOutputs, activeActionId]);

  const status = [
    { id: 200, hasOutput: !!action200Response && action200Response?.length > 0, response: action200Response },
    { id: 400, hasOutput: !!action400Response && action400Response?.length > 0, response: action400Response },
    { id: 500, hasOutput: !!action500Response && action500Response?.length > 0, response: action500Response }
  ].filter((n) => n?.id === 200 || n.hasOutput);

  const selectedActionResponse = useMemo(() => {
    const activeStatus = status?.find((n) => n.id === activeStatusId);
    const response = activeStatus?.response;
    return normalizeToArray(response)?.filter(Boolean);
  }, [status, activeStatusId]);

  const responseInput = getResponseInput(selectedActionResponse, responseMapperId, mapperTab);

  return responseInput;
};

export default useAppScreenResponseInput;
